import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "parentHashTree",
  standalone: false,
})
export class ParentHashTreePipe implements PipeTransform {
  transform(setencehashes: any, hashes: any, lookup: any): any {
    if (setencehashes && hashes && lookup) {
      let categories = [];
      let parents = [];
      for (let item of setencehashes) {
        let id = Object.keys(hashes).find((key) => hashes[key] === item);
        if (id) {
          let newhash = {
            id: lookup[id].id,
            name: lookup[id].label,
            childrenref: lookup[id].children,
          };
          categories.push(newhash);
        }
      }
      if (categories.length > 0) {
        for (let category of categories) {
          if (category.childrenref) {
            const categorychild = category.childrenref.find(
              (child) => child.id === null,
            );
            let childrenlist = [];
            if (!categorychild && category.childrenref.length > 0) {
              for (let child of category.childrenref) {
                let childcategory = categories.find(
                  (obj) => obj.id === child.value,
                );
                if (childcategory) {
                  childcategory.parent = category.id;
                  delete childcategory.childrenref;
                  category.parent = 0;
                  childrenlist.push(childcategory);
                  category.children = childrenlist;
                }
              }
            }
          }
        }
        for (let category of categories) {
          if (!("parent" in category)) {
            category.parent = 0;
          }
          if (category.parent == 0) {
            parents.push(category);
            delete category.childrenref;
          }
        }
      }
      return parents;
    }
  }
}
